import { render, staticRenderFns } from "./buildDetail.vue?vue&type=template&id=590bde4a&scoped=true&"
import script from "./buildDetail.vue?vue&type=script&lang=js&"
export * from "./buildDetail.vue?vue&type=script&lang=js&"
import style0 from "./buildDetail.vue?vue&type=style&index=0&id=590bde4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590bde4a",
  null
  
)

export default component.exports